<template>
  <div>
    <section
      class="
        w-full
        flex
        justify-center
        items-center
        flex-col
        lg:flex-row
        border-none
      "
    >
      <v-data-table
        v-model="alumnos"
        :headers="headers"
        :items="$root.posiblesAlumnos"
        item-key="num"
        show-select
        single-select
        @item-selected="handleClick"
        class="w-full mb-12"
      >
      </v-data-table>
    </section>
    <v-flex justify-between>
      <v-btn text @click="back">Volver</v-btn>
      <v-btn
        :disabled="$root.alumno === null"
        color="primary"
        :loading="loading"
        @click="next"
        >Continuar</v-btn
      >
    </v-flex>
    <v-snackbar v-model="snackbar" multi-line centered>
      El alumno seleccionado no tiene equipos asociados.
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="snackbar = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "StepTwo",

  props: {
    step: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      snackbar: false,
      alumnos: [],
      headers: [
        {
          align: "start",
          sortable: false,
          text: "ID Curso",
          value: "ID_Curso",
        },
        {
          text: "ID Alumno",
          value: "ID_Alumno",
        },
        {
          text: "Nombre",
          value: "nombre",
        },
        {
          align: "end",
          sortable: false,
          text: "Apellidos",
          value: "apellidos",
        },
      ],
    };
  },

  methods: {
    handleClick(event) {
      this.$root.alumno = event.value ? event.item : null;
    },
    back() {
      this.$root.alumno = null;
      this.$root.posiblesAlumnos = [];
      this.$emit("change-step", this.step - 1);
    },
    next() {
      this.loading = true;

      window.CmsApi.hook(this.$root.hookEndPoint, {
        action: "getDispositivos",
        data: JSON.stringify({ alumno: this.$root.alumno.num }),
      })
        .then((response) => {
          if (response.data.datos !== null) {
            this.$root.dispositivos = response.data.datos.registros;

            this.$emit("change-step", this.step + 1);
          } else {
            this.snackbar = true;
          }
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style>
.hover\:bg-blue-600:hover {
  background-color: #114a86 !important;
}
</style>
